import React, { useEffect } from "react";
import { Card, CardHeader } from "reactstrap";
import Quetionnair from "./Module/Quetionnair";

import { AnswerProvider } from "./Module/AnswerContext";
import EvaluationForm from "./Module/EvaluationForm";
import { useMyOrgInfo } from "../../../Layout/AppMain/LoginStatusContext";

const EvaluationDashboard = () => {
  const myOrgInfo = useMyOrgInfo();
  const myOrgId = myOrgInfo.id;
  if (!myOrgId) {
    window.location.href = "/#/dashboards/faq";
  }

  // useEffect(() => {
  //   if (myOrgId) {
  //   } else {
  //     alert(
  //       "このページを利用するには「組織登録」が必要です。\n詳しくはFAQをご覧ください。"
  //     );
  //     window.location.href = "/#/dashboards/faq";
  //   }
  // }, []);

  return (
    <div>
      <Card className="mb-2">
        <CardHeader className="org_title">
          <h4 className="org_name" style={{ marginLeft: 0 }}>
            組織診断
          </h4>
        </CardHeader>
      </Card>
      {/* <AnswerProvider child={<EvaluationForm />} /> */}
      <AnswerProvider child={<Quetionnair />} myOrgId={myOrgId} />
    </div>
  );
};

export default EvaluationDashboard;
